import { createSlice } from "@reduxjs/toolkit";
import { userService } from "../services/userService";
import { createCustomAsyncThunk } from "./utils";

export const login = createCustomAsyncThunk(
    "user/login",
    async data => await userService.login(data)
)

export const getUserInfo = createCustomAsyncThunk(
    "user/userInfo/get",
    async () => await userService.getUserInfo()
)

const userSlice = createSlice({
    name: "user",
    initialState: {
        isLoading: true,
        isAuthenticated: false,
        error: null,
        userInfo: null,
    },
    reducers: {
        logout: state => {
            userService.logout()
            state.isAuthenticated = false
            state.isLoading = false
            state.userInfo = null
        },
    },
    extraReducers: builder => {
        builder
            .addCase(login.pending, state => {
                state.isAuthenticated = false
                state.isLoading = true
            })
            .addCase(login.fulfilled, state => {
                state.isAuthenticated = true
                state.isLoading = false
            })
            .addCase(login.rejected, (state, action) => {
                state.isAuthenticated = false
                state.isLoading = false
                state.error = action.error
            })

            .addCase(getUserInfo.pending, state => { state.isLoading = true })
            .addCase(getUserInfo.fulfilled, (state, action) => {
                state.userInfo = action.payload
                state.isAuthenticated = true
                state.isLoading = false
            })
            .addCase(getUserInfo.rejected, (state, action) => {
                state.userInfo = null
                state.isLoading = false
                state.isAuthenticated = false
                state.error = action.error
            })
    }
})

export const { logout } = userSlice.actions

export default userSlice.reducer